/**
 * package: com.inq.stage
 * class: IDragResize
 * root Object
 * @constructor
 */
com.inq.stage.IDragResize = function() {};
$hxClasses['com.inq.stage.IDragResize'] = com.inq.stage.IDragResize;
/** @private @type {Array} */
com.inq.stage.IDragResize.__name__ = ["com","inq","stage","IDragResize"];

/**
 * whenDone
 *
 * $type TFun([],TEnum(Void,[]))
 * public function whenDone ():Void
 * @public
 * @this com.inq.stage.IDragResize
 * @return {void}
 */
com.inq.stage.IDragResize.prototype.whenDone = null;

/**
 * setDragBorder
 *
 * $type TFun([],TEnum(Void,[]))
 * private function setDragBorder():Void
 * @private
 * @this com.inq.stage.IDragResize
 * @return {void}
 */
com.inq.stage.IDragResize.prototype.setDragBorder = null;

/**
 * setTop
 *
 * $type TFun([{ name => top, t => TInst(Int,[]), opt => false }],TEnum(Void,[]))
 * private function setTop(top:Int):Void
 * @private
 * @this com.inq.stage.IDragResize
 * @param {number}  top 
 * @return {void}
 */
com.inq.stage.IDragResize.prototype.setTop = null;

/**
 * setLeft
 *
 * $type TFun([{ name => left, t => TInst(Int,[]), opt => false }],TEnum(Void,[]))
 * private function setLeft(left:Int):Void
 * @private
 * @this com.inq.stage.IDragResize
 * @param {number}  left 
 * @return {void}
 */
com.inq.stage.IDragResize.prototype.setLeft = null;

/**
 * getDefaultMax
 *
 * $type TFun([],TDynamic(null))
 * private function getDefaultMax():Dynamic
 * @private
 * @this com.inq.stage.IDragResize
 * @return {null}
 */
com.inq.stage.IDragResize.prototype.getDefaultMax = null;

/**
 * getDefaultMin
 *
 * $type TFun([],TDynamic(null))
 * private function getDefaultMin():Dynamic
 * @private
 * @this com.inq.stage.IDragResize
 * @return {null}
 */
com.inq.stage.IDragResize.prototype.getDefaultMin = null;
/** @type {com.inq.stage.IDragResize} */
com.inq.stage.IDragResize.prototype.__class__ = com.inq.stage.IDragResize;
